/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { GeneralContextFunc } from "../../Context/GeneralContex";
import { getAllCategoryData } from "../../Services/DashboardApi";
import { Text, Heading, Button, Box, Flex } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { ChevronDownIcon, ChevronRightIcon } from "@radix-ui/react-icons";

const Categories = () => {
  const navigate = useNavigate();
  const { initAlert, setloader } = GeneralContextFunc();
  const [CategList, setCategList] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});

  useEffect(() => {
    setloader(true);
    getAllCategoryData()
      .then((res) => {
        setCategList([...res?.sortedData]);
        // initAlert(res?.message);
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  }, []);

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const toggleSubCategory = (categoryId, subCategoryIndex) => {
    const key = `${categoryId}-${subCategoryIndex}`;
    setExpandedCategories(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  return (
    <div style={{ marginLeft: "4rem", marginRight: "4rem" }}>
      <Heading size="8" align="left" my="5">
        Categories
      </Heading>
      
      <Box style={{ maxWidth: "1200px" }}>
        {CategList?.map((data, i) => (
          <Box 
            key={data.id || i} 
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              marginBottom: "16px",
              overflow: "hidden",
              backgroundColor: "#ffffff"
            }}
          >
            {/* Category Header */}
            <Flex 
              align="center" 
              justify="between"
              style={{
                padding: "16px 20px",
                backgroundColor: "#f8fafc",
                borderBottom: expandedCategories[data.id] ? "1px solid #e2e8f0" : "none",
                cursor: "pointer",
                transition: "background-color 0.2s"
              }}
              onClick={() => toggleCategory(data.id)}
            >
              <Flex align="center" gap="3">
                {expandedCategories[data.id] ? (
                  <ChevronDownIcon width="20" height="20" />
                ) : (
                  <ChevronRightIcon width="20" height="20" />
                )}
                <Text size="5" weight="bold" style={{ color: "#1e293b" }}>
                  {i + 1}. {data?.categoryName}
                </Text>
              </Flex>
              <Text size="3" style={{ color: "#64748b" }}>
                {data?.subCategories?.length || 0} subcategories
              </Text>
            </Flex>

            {/* Category Content */}
            {expandedCategories[data.id] && (
              <Box style={{ padding: "0" }}>
                {data?.subCategories?.map((subData, index) => (
                  <Box 
                    key={`${data.id}-${index}`}
                    style={{
                      borderBottom: index < data.subCategories.length - 1 ? "1px solid #f1f5f9" : "none"
                    }}
                  >
                    {/* Subcategory Header */}
                    <Flex 
                      align="center" 
                      justify="between"
                      style={{
                        padding: "12px 20px 12px 40px",
                        backgroundColor: "#fefefe",
                        cursor: "pointer",
                        transition: "background-color 0.2s"
                      }}
                      onClick={() => toggleSubCategory(data.id, index)}
                    >
                      <Flex align="center" gap="3">
                        {expandedCategories[`${data.id}-${index}`] ? (
                          <ChevronDownIcon width="16" height="16" />
                        ) : (
                          <ChevronRightIcon width="16" height="16" />
                        )}
                        <Text size="4" weight="medium" style={{ color: "#334155" }}>
                          {subData.name}
                        </Text>
                      </Flex>
                      <Text size="2" style={{ color: "#94a3b8" }}>
                        {subData.resourceItems?.length || 0} items
                      </Text>
                    </Flex>

                    {/* Subcategory Content */}
                    {expandedCategories[`${data.id}-${index}`] && (
                      <Box style={{ padding: "0 20px 16px 60px", backgroundColor: "#fafbfc" }}>
                        <Box style={{ 
                          display: "grid", 
                          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                          gap: "8px",
                          marginTop: "12px"
                        }}>
                          {subData.resourceItems?.map((item, itemIndex) => (
                            <Box 
                              key={`${data.id}-${index}-${itemIndex}`}
                              style={{
                                padding: "8px 12px",
                                backgroundColor: "#ffffff",
                                border: "1px solid #e2e8f0",
                                borderRadius: "6px",
                                fontSize: "14px",
                                color: "#475569"
                              }}
                            >
                              {item}
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </div>
  );
};

export default Categories;
